module.exports = __webpack_public_path__ + "static/media/campus-food-truck-catering-2.271a2236.jpeg";